import styled from 'styled-components';

export const FormModalContainer = styled.div`
    width: 569px;
    padding: 25px 100px;

    background-color: #000;
    border-radius: 16px;
    border: 1px solid #353535;
    position: relative;

    display: flex;
    justify-content: center;
`;

export const FormModalContent = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const FinishButton = styled.button`
    width: 116px;
    height: 39.6px;
    border-radius: 100px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5), 0 2px 4px 0 #641221;
    background-image: linear-gradient(to bottom, #ff6b00, #fa2462);
    border: none;
    font-size: 16px;
    color: white;
    weight: bold;
    text-transform: uppercase;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddWorkoutDescriptionModal/style.js